import type { BalanceType } from '../../api/fetchers/userInfo/types';
import type { CoreStoreType } from '../../store/CoreStore';

export enum IntegrationApi {
  BridgeApi = 'bridge_api',
  DBOX = 'dbox',
  Default = 'default',
  Empty = '',
  GGNet = 'GGNet',
  PaddyPower = 'paddy_power',
  SkyVegas = 'sky_vegas',
}

// Output
export enum OutgoingMessage {
  RoundStart = 'gameRoundStarted',
  RoundEnd = 'gameRoundEnded',

  GameLoadStart = 'gameLoadingStarted',
  GameLoadProgress = 'gameLoadingProgress',
  GameLoadEnd = 'gameLoadingEnded',

  OpenCashier = 'openCashier',
  CloseContainer = 'notifyCloseContainer',

  RealityCheckShown = 'RC_SHOWN',
  RealityCheckContinue = 'RC_CONTINUE',
  RealityCheckQuit = 'RC_QUIT',

  GameQuit = 'gameQuit',
  GameReady = 'gameReady',
  GameActive = 'gameActive',

  UpdateBalance = 'updateBalance',
  UpdateBets = 'updateBets',
  UpdateSettings = 'updateSettings',
  UpdateWin = 'updateWin',

  BetsClosed = 'betsClosed',

  ErrorMessage = 'errorMessage',

  GoToGame = 'goToGame', // This event is triggered when we switch one game to another game.
  GoFromGame = 'goFromGame', // This event is triggered when we switch one game from another game.
  GameChange = 'GameChange', // This event is triggered when we switch game by swipe.
}

interface BalanceInfo {
  balance?: Partial<BalanceType>;
}

interface ErrorMessageInfo {
  errorCode?: string;
  errorMessage?: string;
}

interface LoadingProgressInfo {
  progress?: number;
}

interface SettingsInfo {
  masterVolume?: number;
}

interface TotalBetInfo {
  totalBet?: number;
}

interface WinInfo {
  winResultAmount?: number;
}

interface SwipeInfo {
  swipeXDeltaValue?: number;
  swipeYDeltaValue?: number;
}

export interface OutgoingInfo
  extends BalanceInfo,
    ErrorMessageInfo,
    LoadingProgressInfo,
    SettingsInfo,
    TotalBetInfo,
    WinInfo,
    SwipeInfo {
  tableId?: string;
  isResponsibleGamingEnabled?: boolean;
}

export interface ICrossOriginCommunicator {
  process(message: MessageEvent<unknown>, store: CoreStoreType): void;
  send(message: OutgoingMessage, info?: OutgoingInfo): void;
  onConnect?(store: CoreStoreType): void;
  cleanup?(): void;
}
